import { useMemo } from 'react';
import { useReducedMotion } from 'framer-motion';

const EASE_OUT = [0.2, 0, 0, 1];

export const createMotionPresets = (reduced = false) => {
  if (reduced) {
    return {
      reduced,
      fadeUp: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.01 },
      },
      scaleIn: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.01 },
      },
      stagger: {
        container: {
          initial: {},
          animate: {},
          transition: { staggerChildren: 0 },
        },
        item: {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          transition: { duration: 0.01 },
        },
      },
      interactive: {
        whileHover: {},
        whileTap: {},
      },
      revealOnScroll: {
        initial: { opacity: 0 },
        whileInView: { opacity: 1 },
        viewport: { once: true, amount: 0.2 },
        transition: { duration: 0.01 },
      },
      staggerReveal: {
        viewport: { once: true, amount: 0.15 },
        container: {
          hidden: {},
          visible: { transition: { staggerChildren: 0 } },
        },
        item: {
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { duration: 0.01 } },
        },
      },
    };
  }

  return {
    reduced,
    fadeUp: {
      initial: { opacity: 0, y: 10 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: 6 },
      transition: { duration: 0.2, ease: EASE_OUT },
    },
    scaleIn: {
      initial: { opacity: 0, scale: 0.98 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.98 },
      transition: { duration: 0.18, ease: EASE_OUT },
    },
    stagger: {
      container: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { staggerChildren: 0.06, delayChildren: 0.03 },
      },
      item: {
        initial: { opacity: 0, y: 8 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.2, ease: EASE_OUT },
      },
    },
    interactive: {
      whileHover: { y: -2, scale: 1.01 },
      whileTap: { scale: 0.995 },
    },
    revealOnScroll: {
      initial: { opacity: 0, y: 22 },
      whileInView: { opacity: 1, y: 0 },
      viewport: { once: true, amount: 0.2 },
      transition: { duration: 0.5, ease: EASE_OUT },
    },
    staggerReveal: {
      viewport: { once: true, amount: 0.15 },
      container: {
        hidden: {},
        visible: { transition: { staggerChildren: 0.07, delayChildren: 0.04 } },
      },
      item: {
        hidden: { opacity: 0, y: 26, scale: 0.97 },
        visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5, ease: EASE_OUT } },
      },
    },
  };
};

export const useMotionPresets = () => {
  const reduced = useReducedMotion();

  return useMemo(() => createMotionPresets(Boolean(reduced)), [reduced]);
};

